import React from "react";
import Button from "../../../components/ui/Button";
import CogitoLogo from "../../../components/ui/CogitoLogo";
import Icon from "../../../components/AppIcon";

const RegistrationHeader = ({ onNavigateToLogin }) => {
  return (
    <div className="text-center space-y-6">
      <div className="flex flex-col items-center space-y-5">
        <CogitoLogo size="md" interactive={false} tagline="future ready" />
        <div className="space-y-2">
          <h1 className="text-3xl font-bold text-foreground">Join Cogito</h1>
          <p className="text-lg text-muted-foreground">
            Craft smarter study rituals with AI-guided insights
          </p>
        </div>
      </div>

      <div className="flex items-center justify-center space-x-2 text-sm">
        <span className="text-muted-foreground">Already have an account?</span>
        <Button
          variant="link"
          size="sm"
          onClick={onNavigateToLogin}
          className="p-0 h-auto font-medium"
        >
          Sign in here
        </Button>
      </div>
    </div>
  );
};

export default RegistrationHeader;
